/**
 * useStreamingPaymentRequired — banner-facing read API.
 *
 * signup-billing-mvp Phase 6 Session 3 (2026-05-13).
 *
 * Thin wrapper around `usePaymentRequiredContext()` — exposes the current
 * signal + a `dismiss()` callback that clears it. The producer side
 * (`useStreaming` in `use-streaming-v2.ts`) uses the lower-level
 * `usePaymentRequiredContext` directly to reach the setter.
 */

import { usePaymentRequiredContext, type PaymentRequiredState } from '@/contexts/PaymentRequiredContext';

export interface UseStreamingPaymentRequiredResult {
  paymentRequired: PaymentRequiredState | null;
  dismiss: () => void;
}

export function useStreamingPaymentRequired(): UseStreamingPaymentRequiredResult {
  const { paymentRequired, setPaymentRequired } = usePaymentRequiredContext();
  return {
    paymentRequired,
    dismiss: () => setPaymentRequired(null),
  };
}
